enum SignupSlideImageHeaderTheme {
    Coral = "coral",
    ElectricBlue = "electric-blue",
    DarkCoral = "dark-coral"
}

export default SignupSlideImageHeaderTheme;